import React from 'react';
import { OKXTicker } from '../types';
import GlassCard from './ui/GlassCard';
import NeonText from './ui/NeonText';

interface MarketDataListProps {
  marketData: OKXTicker[];
  loading: boolean;
}

const MarketDataList: React.FC<MarketDataListProps> = ({ marketData, loading }) => {
  // 格式化成交量
  const formatVolume = (vol: number) => {
    if (vol >= 1000000000) {
      return `${(vol / 1000000000).toFixed(1)}B`;
    } else if (vol >= 1000000) {
      return `${(vol / 1000000).toFixed(1)}M`;
    } else if (vol >= 1000) {
      return `${(vol / 1000).toFixed(1)}K`;
    } else {
      return vol.toFixed(0);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto"></div>
      </div>
    );
  }

  return (
    <div className="space-y-3 py-4">
      {marketData.slice(0, 10).map((ticker: OKXTicker) => {
        const price = parseFloat(ticker.last) || 0;
        const openPrice = parseFloat(ticker.open24h) || 0;
        const volume = parseFloat(ticker.volCcy24h) || 0;
        const changePercent = openPrice > 0 ? ((price - openPrice) / openPrice) * 100 : 0;

        return (
          <GlassCard
            key={ticker.instId}
            className="p-4 hover:scale-105 transition-transform duration-200 origin-center mx-2"
          >
            <div className="flex justify-between items-center w-full">
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-white text-lg truncate">{ticker.instId.replace('-USDT', '')}</p>
                <p className="text-sm text-white/60 truncate">24h成交量: {formatVolume(volume)} USDT</p>
              </div>
              <div className="text-right flex-shrink-0 ml-4">
                <NeonText className="text-lg" color="cyan">
                  ${price > 0 ? price.toFixed(2) : '0.00'}
                </NeonText>
                <NeonText className="text-sm block" color={changePercent >= 0 ? 'green' : 'pink'}>
                  {changePercent >= 0 ? '+' : ''}
                  {changePercent.toFixed(2)}%
                </NeonText>
              </div>
            </div>
          </GlassCard>
        );
      })}
    </div>
  );
};

export default MarketDataList;
